module.exports = __webpack_public_path__ + "img/menu.3ca57c78.svg";